/*
 * Copyright (C) 2019 Toshiba Corporation
 * SPDX-License-Identifier: Apache-2.0
 */

import { DThemeDialogDate } from "../../d-dialog-date";
import { DThemeDarkDialogFitted } from "./d-theme-dark-dialog-fitted";

export class DThemeDarkDialogDate extends DThemeDarkDialogFitted implements DThemeDialogDate {}
